











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ITransaction, IDelegate } from "@/interfaces";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["activeDelegates"]),
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class TableLockTransactionsMobile extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public transactions: ITransaction[] | null;

  private activeDelegates: IDelegate[];
  private smartbridgeFilter: string;
}
